export default function CookiesRoute() {
	return (
		<div className="container mx-auto px-4 py-8">
			<h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
			<div className="prose max-w-none">
				<p className="text-lg mb-6">
					This Cookie Policy explains how TrueTenant uses cookies and similar
					technologies to recognize you when you visit our website.
				</p>

				<div className="bg-gray-50 p-6 rounded-lg mb-8">
					<h2 className="text-2xl font-semibold mb-4">What are cookies?</h2>
					<p className="text-gray-700 mb-4">
						Cookies are small data files that are placed on your computer or
						mobile device when you visit a website. Cookies are widely used by
						website owners to make their websites work, or to work more
						efficiently, as well as to provide reporting information.
					</p>
				</div>

				<div className="space-y-8">
					<div>
						<h2 className="text-xl font-semibold mb-3">
							Types of cookies we use
						</h2>
						<div className="space-y-4">
							<div>
								<h3 className="text-lg font-medium mb-2">Essential Cookies</h3>
								<p className="text-gray-600">
									These cookies are necessary for the website to function and
									cannot be switched off. They are usually only set in response
									to actions made by you which amount to a request for services,
									such as setting your privacy preferences, logging in, or
									filling in forms.
								</p>
							</div>
							<div>
								<h3 className="text-lg font-medium mb-2">Analytics Cookies</h3>
								<p className="text-gray-600">
									These cookies allow us to count visits and traffic sources so
									we can measure and improve the performance of our site. They
									help us to know which pages are the most and least popular and
									see how visitors move around the site.
								</p>
							</div>
							<div>
								<h3 className="text-lg font-medium mb-2">Functional Cookies</h3>
								<p className="text-gray-600">
									These cookies enable the website to provide enhanced
									functionality and personalization. They may be set by us or by
									third-party providers whose services we have added to our
									pages.
								</p>
							</div>
						</div>
					</div>

					<div>
						<h2 className="text-xl font-semibold mb-3">
							Managing your cookie preferences
						</h2>
						<p className="text-gray-600 mb-4">
							You can set or amend your web browser controls to accept or refuse
							cookies. If you choose to reject cookies, you may still use our
							website though your access to some functionality and areas of our
							website may be restricted.
						</p>
						<div className="bg-blue-50 p-4 rounded-lg">
							<h3 className="font-semibold mb-2">Browser Settings</h3>
							<p className="text-sm text-gray-600">
								Most web browsers allow you to manage cookies through their
								settings preferences. To learn more about how to manage cookies,
								visit{' '}
								<a
									href="https://www.allaboutcookies.org"
									className="text-blue-600 hover:underline"
								>
									allaboutcookies.org
								</a>
								.
							</p>
						</div>
					</div>

					<div>
						<h2 className="text-xl font-semibold mb-3">
							Updates to this policy
						</h2>
						<p className="text-gray-600">
							We may update this Cookie Policy from time to time to reflect
							changes in our practices or for other operational, legal, or
							regulatory reasons. The date at the top of this Cookie Policy
							indicates when it was last updated.
						</p>
					</div>
				</div>

				<div className="mt-8 p-6 bg-gray-50 rounded-lg">
					<h2 className="text-xl font-semibold mb-3">Contact Us</h2>
					<p className="text-gray-600 mb-2">
						If you have any questions about our use of cookies, please contact
						us at:
					</p>
					<p className="text-gray-600">
						<strong>Email:</strong> privacy@truetenant.com
						<br />
						<strong>Address:</strong> TrueTenant Privacy Team, [Your Address]
					</p>
				</div>
			</div>
		</div>
	)
}
